export const ACTION_TYPE = {
  SET_JOB_CATEGORY: "SET_JOB_CATEGORY",
  SET_DYNAMIC_MENU: "SET_DYNAMIC_MENU",
  SET_DASHBOARD_LAST_UPDATE: "SET_DASHBOARD_LAST_UPDATE",
};

export const setJobCategory = (payload) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.SET_JOB_CATEGORY,
      payload: payload,
    });
  };
};

export const setDashboardLastUpdate = (payload) => (dispatch) => {
  dispatch({ type: ACTION_TYPE.SET_DASHBOARD_LAST_UPDATE, payload: payload });
};

export const setDynamicMenu = (payload) => (dispatch) => {
  dispatch({ type: ACTION_TYPE.SET_DYNAMIC_MENU, payload: payload });
};
